var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-form',{attrs:{"id":_vm.id,"type":"article","plural":"articles"},model:{value:(_vm.article),callback:function ($$v) {_vm.article=$$v},expression:"article"}})}
var staticRenderFns = []

export { render, staticRenderFns }